import * as Yup from 'yup';

export const predictMessageYopValidation = () => {
  return Yup.object().shape({
    url: Yup.string().required('required'),
    message: Yup.string().required('required'),
  });
};
